import { useTailgateGrid } from '../hooks/useTailgateGrid'

import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react'

import { GridTestingZone } from '../grid-testing-zone/components/GridTestingZone'
import { scrollbarStyle } from '../styles/styles'
import { GridModalBody } from './GridModalBody'
import { GridModalDetails } from './GridModalDetails'
import { GridModalHeader } from './GridModalHeader'

export const TailgateGridModal = () => {
  const {
    clearBoxes,
    DummyPlayer,
    resetVideoFrame,
    shouldRenderDummyPlayer,
    isTailgateGridOpen,
    onTailgateGridClose,
  } = useTailgateGrid()
  const testModalDisclosure = useDisclosure()

  const handleClose = () => {
    onTailgateGridClose()
    resetVideoFrame()
    clearBoxes()
  }

  return (
    <>
      <Modal
        isCentered
        isOpen={isTailgateGridOpen}
        motionPreset='slideInBottom'
        onClose={handleClose}
        scrollBehavior='inside'
        size='6xl'
      >
        <ModalOverlay />
        <ModalContent
          bg='#fff'
          px={{ base: '5px', sm: '15px', md: '30px' }}
          py='30px'
        >
          <ModalHeader p={0} w='100%'>
            <GridModalHeader />
          </ModalHeader>
          <ModalCloseButton color='#000' mt='5px' opacity={0.4} />
          <ModalBody p={0} sx={scrollbarStyle}>
            <GridModalDetails />
            <GridModalBody
              onClose={handleClose}
              onOpenTestModal={testModalDisclosure.onOpen}
            />
          </ModalBody>
        </ModalContent>
        {shouldRenderDummyPlayer && <DummyPlayer />}
      </Modal>
      <GridTestingZone
        isOpen={testModalDisclosure.isOpen}
        onClose={testModalDisclosure.onClose}
      />
    </>
  )
}
